import _Stack from "@mui/material/Stack";
var _UserDivider;
import React from 'react';
import { styled } from '@mui/material/styles';
import Menu, { menuClasses } from '@mui/material/Menu';
import { menuItemClasses } from '@mui/material/MenuItem';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import itemTypes from '../utils/itemTypes';
import SovosAvatar from '../../sovos-avatar';
import SovosDivider from '../../sovos-divider';
import SovosListItemIcon from '../../sovos-list-item-icon';
import SovosListItemText from '../../sovos-list-item-text';
import SovosMenuItem from '../../sovos-menu-item';
import SovosTypography from '../../sovos-typography';
const UserMenuItem = styled('li')(_ref => {
  let {
    theme: {
      palette,
      typography
    }
  } = _ref;
  return {
    order: '-1',
    '& .navigationUserMenu__userName': {
      fontWeight: typography.fontWeightBold,
      overflowWrap: 'break-word'
    },
    '& .navigationUserMenu__email': {
      color: palette.primary.main,
      textDecoration: 'underline',
      overflowWrap: 'break-word'
    }
  };
});
const UserDivider = styled(SovosDivider)(_ref2 => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref2;
  return {
    backgroundColor: palette.divider,
    margin: "".concat(spacing(0.5), " ").concat(spacing(2))
  };
});
export const BaseMenu = styled(Menu)(_ref3 => {
  let {
    theme: {
      spacing
    }
  } = _ref3;
  return {
    ["& .".concat(menuClasses.list, ":has(> .navigationUserMenu)")]: {
      paddingTop: 0
    },
    ["& .".concat(menuClasses.paper)]: {
      minWidth: spacing(30)
    },
    ["& .".concat(menuClasses.list)]: {
      display: 'flex',
      flexDirection: 'column'
    },
    ["& .".concat(menuItemClasses.root, " .").concat(listItemIconClasses.root)]: {
      marginInlineEnd: spacing(1),
      minWidth: 'unset',
      '& svg': {
        height: spacing(2),
        width: spacing(2)
      }
    }
  };
});
export const renderUserMenuHeader = _ref4 => {
  var _userMenuProps$name;
  let {
    menuName,
    userMenuProps,
    userName
  } = _ref4;
  if (menuName !== 'user') {
    return null;
  }
  return /*#__PURE__*/React.createElement(UserMenuItem, {
    className: "navigationUserMenu"
  }, /*#__PURE__*/React.createElement(_Stack, {
    direction: "row",
    padding: 2,
    spacing: 1,
    useFlexGap: true
  }, /*#__PURE__*/React.createElement(SovosAvatar, {
    name: (_userMenuProps$name = userMenuProps.name) !== null && _userMenuProps$name !== void 0 ? _userMenuProps$name : userName,
    size: "large",
    surname: userMenuProps.surname
  }), /*#__PURE__*/React.createElement(_Stack, {
    direction: "column",
    spacing: 0.75,
    useFlexGap: true
  }, /*#__PURE__*/React.createElement(SovosTypography, {
    className: "navigationUserMenu__userName",
    component: "div",
    variant: "body1"
  }, userMenuProps.name || userMenuProps.surname ? "".concat(userMenuProps.name, " ").concat(userMenuProps.surname) : userName), userMenuProps.email && /*#__PURE__*/React.createElement(SovosTypography, {
    className: "navigationUserMenu__email",
    component: "div",
    variant: "body2"
  }, userMenuProps.email))), _UserDivider || (_UserDivider = /*#__PURE__*/React.createElement(UserDivider, null)));
};
export const renderMenuItems = _ref5 => {
  let {
    classNameRoot,
    items,
    menuName,
    handleMenuClick
  } = _ref5;
  return items === null || items === void 0 ? void 0 : items.map((item, idx) => {
    if (item.type === itemTypes.DIVIDER) {
      // eslint-disable-next-line react/no-array-index-key
      return /*#__PURE__*/React.createElement(SovosDivider, {
        key: "divider-".concat(idx)
      });
    }
    return /*#__PURE__*/React.createElement(SovosMenuItem, {
      className: "".concat(classNameRoot, "__").concat(menuName, "MenuItem--").concat(item.label),
      onClick: () => handleMenuClick(item.action),
      key: item.label
    }, item.icon && /*#__PURE__*/React.createElement(SovosListItemIcon, null, /*#__PURE__*/React.createElement(item.icon, null)), /*#__PURE__*/React.createElement(SovosListItemText, {
      primary: item.label
    }));
  });
};